import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminDashboardComponent } from '../dashboard'
import { VendorActivityComponent,VendorInvoicesComponent, UserActivityLogComponent, EmailDeliveryReportComponent, ErrorLogComponent, EmailReportAnonymousUsersComponent } from './components/index';
export const routes: Routes = [
  { path: '', component: VendorActivityComponent },
  { path: 'vendor-activity', component: VendorActivityComponent },
  { path: 'vendor-invoices', component: VendorInvoicesComponent },
  { path: 'user-activity-log', component: UserActivityLogComponent },
  { path: 'email-delivery-report', component: EmailDeliveryReportComponent },
  { path: 'error-log', component: ErrorLogComponent },
  { path: 'email-report-anonymous-users', component: EmailReportAnonymousUsersComponent }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }
